/**
 * Coupons API endpoint constants.
 */
export const COUPONS_ENDPOINTS = {
    GET_AVAILABLE: '/coupons/available',
};
//# sourceMappingURL=endpoints.js.map